"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _Button = _interopRequireDefault(require("../Button"));
var NotAvailable = function NotAvailable(_ref) {
  var onDownload = _ref.onDownload,
    onClose = _ref.onClose;
  var _useTranslation = (0, _reactI18next.useTranslation)(),
    t = _useTranslation.t;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex items-center justify-center h-full p-10 overflow-hidden",
    onClick: onClose
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "text-center",
    onClick: function onClick(e) {
      return e.stopPropagation();
    }
  }, /*#__PURE__*/_react["default"].createElement("img", {
    src: t('no-preview-available.png'),
    alt: "no-preview-available",
    width: "500",
    height: "500",
    style: {
      height: '70vh',
      width: 'auto'
    },
    onClick: onClose
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "relative",
    style: {
      top: -50
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "text-xl font-bold leading-loose mb-4"
  }, t('preview.notAvaliable')), /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    size: "sm",
    className: "rounded-full text-xs px-12 py-2 !font-normal",
    onClick: onDownload
  }, t('button.download')))));
};
var _default = exports["default"] = NotAvailable;
//# sourceMappingURL=NotAvailable.js.map